<template>
  <HXContentCard title="Calificaciones del Curso" defaultToBack>
    <div class='pl-5 py-3'>
      <div class='pr-5'>
        <p>Progreso General del Curso</p>
        <b-progress :value="EvaluacionesCompletadas" :max="CantidadEvaluaciones" variant='info'
        show-progress></b-progress>
        <!-- <progress-bubble v-b-tooltip.hover title="Progreso General del Curso" size="md" :max='CantidadEvaluaciones'
          :percent="Number(EvaluacionesCompletadas)" /> -->

      </div>
      <div class="table-responsive p-4">
        <table id="datatable_notas" class="table table-bordered table-responsive-md table-striped text-center">
          <thead>
            <tr>
              <!-- <th>Modulo</th> -->
              <th>Actividad</th>
              <th>Calificación</th>
              <th>Estado</th>
              <th>Fecha de Entrega</th>
            </tr>
          </thead>
          <tbody>


          <tr v-for="item in listaItems" :key="item.id">
              <!-- <td></td> -->
              <td style="cursor: pointer" @click="$router.push(`/helex/Ayuda/Academia/InformacionEvaluacion/${item.Id}`)">{{ item.Titulo }}</td>
              <td class='d-flex justify-content-center' style='gap: 7px;'>{{ item.Nota }} <b-progress :value="item.Nota"
                  max="5" variant='info' style='width: 50px; border-radius: 50px;' show-progress></b-progress></td>
              <td><b-badge :variant="Number(item.Nota) !== 0 ? 'success' : 'danger'">{{ Number(item.Nota) !== 0 ?
                'Completado' : 'Pendiente' }}</b-badge></td>
              <td>{{ (item.FechaAplicacion !== null )?item.FechaAplicacion.split("T")[0]: 'Fecha No Registrada' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Total:</strong></td>
              <td><strong>{{PonderadoActual}}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </HXContentCard>
</template>

<script>
  import { core } from "@/config/pluginInit";
  // import progressBubble from "@/components/progress/progressBubble.vue";
  export default {
    components: {
      // progressBubble
    },
    data() {
      return {
        persona: {},
        listaItems: [],
        CantidadEvaluaciones: 0,
        EvaluacionesCompletadas: 0,
        PonderadoActual: 0
      }
    },
    async mounted() {
      this.$isLoading(true);
      this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
      core.index();
      await this.getData();
      window.$("#datatable_notas").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
      this.$isLoading(false);
    },
    methods: {
      async getData() {
        try {
          let responseNota = await this.$store.dispatch("hl_get", {
            path: `CursosAcademia/ObtenerNotas/${this.$route.params.id}/persona/${this.persona.id}`,
          })
          if (responseNota.respuesta) {
            this.listaItems = responseNota.data.Notas;
            this.CantidadEvaluaciones = this.listaItems.length;
            this.PonderadoActual = responseNota.data.NotaFinal;
            this.EvaluacionesCompletadas = this.listaItems.filter(item => item.FechaAplicacion !== null).length;
          }
        } catch (error) {
          console.error("Error: " + error);
        }
      }
    }
  }
</script>

<style scoped>
  .progress {
    background-color: #e9ecef;
  }
</style>
